import { useState, useEffect } from "react";
import "@/App.css";
import { HeroSection } from "@/components/HeroSection";
import { PromoBanner } from "@/components/PromoBanner";
import { CategoryNav } from "@/components/CategoryNav";
import { MenuSections } from "@/components/MenuSections";
import { HistorySection } from "@/components/HistorySection";
import { ContactSection } from "@/components/ContactSection";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { Footer } from "@/components/Footer";
import { CartProvider } from "@/context/CartContext";
import { CartDrawer, FloatingCartButton } from "@/components/CartDrawer";
import { CATEGORIES } from "@/data/menuData";

function App() {
  const [activeCategory, setActiveCategory] = useState(CATEGORIES[0].id);

  useEffect(() => {
    const handleScroll = () => {
      const offset = 120;
      for (let i = CATEGORIES.length - 1; i >= 0; i--) {
        const el = document.getElementById(CATEGORIES[i].id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= offset) {
            setActiveCategory(CATEGORIES[i].id);
            return;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <CartProvider>
      <div className="min-h-screen bg-[#E8E8E8]">
        <HeroSection />
        <PromoBanner />
        <CategoryNav activeCategory={activeCategory} />
        <MenuSections />
        <HistorySection />
        <ContactSection />
        <Footer />
        <WhatsAppButton />
        <FloatingCartButton />
        <CartDrawer />
      </div>
    </CartProvider>
  );
}

export default App;
